import React from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';
import Index from './index';
import { default as _AskAnalystModal, AskAnalystModalProps } from './components/widgets/Analysts/AskAnalystModal';
import { LockedContentView } from './components/LockedContent';

import withQueryClientAndRouter from './components/withQueryClientAndRouter';

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: Index,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  errorBoundary(err, info, props) {
    // Customize the root error boundary for your microfrontend here.
    return <div>Error</div>;
  },
  renderType: 'createRoot',
});

export const { bootstrap, mount, unmount } = lifecycles;
export { creditsightsSyncDataSubject$, SyncDataSubject } from './sharedSubjects';
export { searchTags } from './services/tags/tags.service';
export { mapSavedSearchesDtoToModel } from './hooks/searches/utils/savedSearches.mappers';
export { getDateRangeDisplayValue } from './pages/MyContent/SearchesTab/CellRenderers/FiltersRenderer/FiltersRenderer.logic';

// All components exported from this MFE should be listed below.
// Each and every component MUST be wrapped with `withQueryClientAndRouter` HOC to avoid runtime errors
const AskAnalystModal = withQueryClientAndRouter(_AskAnalystModal);
const LockedContent = withQueryClientAndRouter(LockedContentView);
export { AskAnalystModal, type AskAnalystModalProps, LockedContent };
